import * as React from 'react';
import TextField from '@mui/material/TextField';

const TextInputComponent = ({ id, label, value, setValue, error, disabled, sx, inputProps, inputLabelProps, type, helperText, placeholder, ...rest }) => {
  return (
    <>
      <TextField
        error={error}
        value={value ?? ''}
        onChange={(e) => setValue(e.target.value)}
        sx={sx}
        fullWidth
        placeholder={placeholder}
        id={id}
        name={id || label?.toLowerCase().replace(/\s+/g, '_')}
        label={label}
        variant="outlined"
        disabled={disabled}
        InputProps={inputProps}
        InputLabelProps={inputLabelProps}
        type={type}
        helperText={helperText}
        {...rest}
      />
    </>
  );
};

export default TextInputComponent;
